import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import englishTranslation from "languages/en.json";
import polishTranslation from "languages/pl.json";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  pl: {
    translation: polishTranslation,
  },
  en: {
    translation: englishTranslation,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["navigator"],
    },
  });

export default i18n;
